import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { applyTheme } from '@/lib/themes.ts'
import { useThemeStore } from '@/stores/theme-store.ts'

/**
 * @file 主题 Provider
 * @description 将 zustand 中的主题 ID 同步到文档 CSS 变量。
 *
 * @whenToUse 应用根节点包裹，保证路由切换后主题仍生效。
 * @whenNotToUse 不要在业务页重复挂载；切换主题请用 `useThemeStore` / `ThemeSwitcher`。
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useThemeStore((state) => state.theme)

  useEffect(() => {
    applyTheme(theme)
  }, [theme])

  return children
}
